import { ArrowUpRight, MapPinned } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { antalyaHubPath } from "@/data/antalyaLocations";
import { istanbulHubPath } from "@/data/istanbulLocations";
import { muglaHubPath } from "@/data/muglaLocations";

export const DoctorVisitLocationGuides = () => {
  const { t, i18n } = useTranslation("doctorVisits");

  return (
    <section
      className="px-4 py-10 sm:px-6 sm:py-12 lg:px-8"
      data-location-guides="doctor-visits"
    >
      <div className="mx-auto grid max-w-[1168px] gap-6 border-y border-border py-8 md:grid-cols-[auto_1fr_auto] md:items-center md:gap-8">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent text-primary">
          <MapPinned className="h-5 w-5" aria-hidden="true" />
        </span>
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
            {t("locationGuides.eyebrow")}
          </p>
          <h2 className="mt-2 text-2xl font-bold tracking-tight text-foreground">
            {t("locationGuides.title")}
          </h2>
          <p className="mt-2 max-w-3xl leading-7 text-muted-foreground">
            {t("locationGuides.description")}
          </p>
        </div>
        <div className="flex flex-col items-start gap-2">
          <Link
            className="inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            to={antalyaHubPath(i18n.language)}
          >
            {t("locationGuides.link")}
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <Link
            className="inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            to={istanbulHubPath(i18n.language)}
          >
            {t("locationGuides.istanbulLink")}
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <Link
            className="inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            to={muglaHubPath(i18n.language)}
          >
            {t("locationGuides.muglaLink")}
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};
